import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { ROLES } from "app/_constants/roles";
import { SharedService } from "app/_services";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class AlphaGuard implements CanActivate {
    constructor(private sharedService: SharedService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        let canActivate =false;
        const {hasCreate,hasRead,hasEdit} = this.sharedService.checkPermissionByRole(route.data.functionality);
        return hasCreate || hasRead || hasEdit;
    }
}